import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Home from "../pages/Home";
// import Profile from "../pages/Profile";
import Login from "../pages/Login";
import PageNotFound from "../pages/404";
import PrivateRoute from "../components/auth/PrivateRoutes";
import { DashBoard, PurchaseOrderAccess, PurchaseOrderManage } from "../pages/dashboard";
import { ROLES } from "../constant/constant";

import { WarehouseRouter } from "./warehouse.router";
import { DataRouter } from "./data.router";
import { PrintRouter } from "./print.route";
import { ReportRouter } from "./report.route";
const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate replace to="/login" />} />
        <Route path="/login" element={<Login />} />

        <Route
          element={<PrivateRoute allowdRole={[ROLES.ADMIN, ROLES.USER]} />}
        >
          {/* <Route path="/dashboard" element={<DashBoard />} /> */}

          <Route path="/dashboard/" exact element={<DashBoard />}>
          <Route index element={<PurchaseOrderAccess />} />
          <Route path="manage/:action" element={<PurchaseOrderManage />} />
        </Route>

          {/* <Route path="/profile" element={<Profile />} /> */}
        </Route>

        <Route element={<PrivateRoute allowdRole={[ROLES.ADMIN]} />}>
          {DataRouter}
          {WarehouseRouter}
          {ReportRouter}
        </Route>

        <Route
          element={
            <PrivateRoute allowdRole={[ROLES.ADMIN, ROLES.USER]} mode="print" />
          }
        >
          {PrintRouter}
        </Route>

        <Route path="/*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
